/**
 * @file 发送boss日志
 */
import getUserId from './getUserId';
import detector from './uaDetect';
import store from '../../store';

const Boss = {
    send(config) {
        let paramValue = []
        if (typeof config === "object" && config != null && !(config === config.window) && Object.getPrototypeOf(config) === Object.prototype && config.params) {
            for (let key in config.params) {
                let cur = config.params[key]
                if (typeof cur == 'object') {
                    cur = JSON.stringify(cur)
                }
                paramValue.push(key + '=' + cur)
            }
            let img = new Image()
            img.onload = function () { }
            if (config.url && config.url.indexOf('?') > -1) {
                img.src = config.url + paramValue.join('&')
            } else {
                img.src = config.url + '?' + paramValue.join('&')
            }
        }
    }
}

/**
 * 获取url参数
 * 
 * @param {string} key 需要获取的参数
 * @param {string} url url值
 */
function query(key, url) {
    var reg = new RegExp("(^|&|\\?|#)" + key + "=([^&#]*)(&|$|#)", "");
    url = url || document.location.href;
    if (typeof url === "undefined") {
        return;
    }
    var match = url.match(reg);
    if (match) {
        return match[2];
    }
    return "";
}


/**
 * 
 * @param {string} sop 用户行为
 * @param {Object} params 上报参数
 */

export default function(sop, params = {}) {

    const kbApp = store.getState().kbApp;
        // alert(JSON.stringify(kbApp))

    let {
        devid = '',
        omgid = '',
        guid = '',
        mainAccount
    } = kbApp;

    let userId = getUserId();
    if(kbApp.userInfo && kbApp.userInfo.userId) {
        userId = kbApp.userInfo.userId;
    }
    const {qbid = ''} = kbApp.userInfo || {};

    Boss.send({
        url: `${window.location.protocol}//h.trace.qq.com/kv`,
        params: {
            attaid: '04f00015696',
            token: '1157547372',
            sOp: sop,
            page_refer: query('refer'),
            hh_uav: detector.app.version,
            hh_ua: detector.app.weixin ? 1 : (detector.app.mqq ? 2 : (detector.app.kuaibao ? 3 : (detector.app.qb ? 4 : 0))),
            dev_type: detector.os.android ? 0 : (detector.os.iphone ? 1 : 0), // devType: 0:android;1:ios
            app_type: detector.app.kuaibao ? 1 : (detector.app.qb ? 0 : -1),
            bucket: '',
            test_bucket: store.getState().testBucket,
            userid: userId,
            dev_id: devid,
            omgid: omgid,
            guid: guid,
            qbid: qbid,
            qb_guid: guid,
            qb_qbid: qbid,
            useridtype: mainAccount,
            _dc: Math.random(),
            ...params
        }
    });
}